module.exports = __webpack_public_path__ + "static/slide4-b7d5e87c630c77aff93e897011d168da.jpg";